import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SEAT_BOOKING,
  SEAT_BOOKING_KPI,
  SEAT_BOOKING_GRAPH,
  LOADER_FALSE,
  LOADER_CHECK,
  TOTAOL_COUNT,
  SEAT_BOOKING_ALL_DATA,
} from '../type';
import axios from 'axios';
import { toast } from 'react-toastify';
import { SeatBlooking, SeatBookingGraph, SeatBookingKpi } from '../../Component/Helpers/api';
import $ from 'jquery';
import { dataLocation } from '../../Component/Helpers/util';
const userDataLocal1 = dataLocation();

var LocationObj = JSON.parse(userDataLocal1);


export const SeatBookingData = (pageDetail) => async (dispatch) => {
  let authToken = JSON.parse(localStorage.getItem("headData"));

  dispatch({ type: LOADING_UI });

  try {
    // First API request
    const res = await axios.post(SeatBlooking.data, pageDetail, {
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    });

    if (res.status === 200) {
      dispatch({ type: SEAT_BOOKING, payload: res.data.data });
   
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: LOADER_CHECK });
      dispatch({ type: TOTAOL_COUNT, payload: res.data.data });

      $(".close").click(); // Close modal if applicable

      // // Update pageDetail with new data
      // pageDetail.row = res.data.data.data.total;

      // try {
      //   // Second API request
      //   const response = await axios.post(SeatBlooking.data, pageDetail, {
      //     headers: {
      //       Authorization: authToken?.spintlyToken,
      //     },
      //   });

      //   if (response.status === 200) {
      //     dispatch({ type: SEAT_BOOKING_ALL_DATA, payload: response.data.data });
      //     $(".close").click();
      //   }
      // } catch (error) {
      //   console.error("Error in second request:", error);
      // }
    } else {
      dispatch({ type: CLEAR_ERRORS });
      toast.error(res.data.message);
    }
  } catch (error) {
    console.error("Error in first request:", error);
    dispatch({ type: CLEAR_ERRORS });
  }
};







export const SeatBookingKpiData = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(SeatBookingKpi.data, pageDetail,{    headers: {

      Authorization: authToken?.spintlyToken,

    }})
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: SEAT_BOOKING_KPI, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        dispatch({ type: TOTAOL_COUNT, payload: res.data.data });

        $('.close').click();
        // toast.success(res.data.message, {

        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {

        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};
export const SeatBookingGraphData = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(SeatBookingGraph.data, pageDetail,{     headers: {

      Authorization: authToken?.spintlyToken,

    }})
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: SEAT_BOOKING_GRAPH, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        dispatch({ type: TOTAOL_COUNT, payload: res.data.data });

        $('.close').click();
        // toast.success(res.data.message, {

        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {

        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const CheckLoader = () => dispatch => {
  dispatch({ type: LOADER_FALSE });
};
